import { defineMessages } from 'react-intl'

const messages = defineMessages({
  room: {
    id: 'global.room',
  },
  holder: {
    id: 'global.holder',
  },
})

export default messages
